import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CurrentUser, SettingDataOutputModel } from '@travel/shared';
import { DataConfig, StorageService } from '@travel/shared/services';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicLoginService {
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;

  constructor(private _httpClient: HttpClient, private _storageService: StorageService, @Inject('environment') private environment: any) {
    this.currentUserSubject = new BehaviorSubject<CurrentUser>(_storageService.get('USER_PROFILE'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): CurrentUser {
    return this.currentUserSubject.value;
  }

  captchaGenerate(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${this.environment.captchaURL}/unsecured/captcha/generate`).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  staticLogin(param: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const user: CurrentUser = new CurrentUser();
      //
      let params = new HttpParams();
      params = params.set('grant_type', 'password');
      params = params.set('username', param.username);
      params = params.set('password', param.password);
      params = params.set('authenticationType', 'static');
      params = params.set('stepNumber', '2');
      params = params.set('captchaId', param.captchaId);
      params = params.set('captchaCode', param.captchaCode);
      params = params.set('organizationPersonRootId', this.settingData.agencyId);
      //
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
      headers = headers.set('Authorization', 'Basic ' + btoa('clientAppId:test'));
      //
      const body = {};
      const options = { params, headers };
      this._httpClient
        .post(`${this.environment.authURL}/oauth/token`, body, options)
        .toPromise()
        .then((res: any) => {
          user.id = res.user_id;
          user.expiresIn = res.expires_in;
          user.token = res.access_token;
          user.refreshToken = res.refresh_token;
          user.username = param.username;
          user.whiteLabelId = this.settingData.whiteLabelId;


          // handle user profile info
          return this._httpClient
            .get(`${this.environment.baseURL}/userProfile/get/${user.id}`, {
              headers: { Authorization: `Bearer ${user.token}` },
            })
            .toPromise();
        })
        .then((c: any) => {
          const { userAccountId, firstName, lastName, birthday, nationalCode, email, iban } = c.result;
          (user.userAccountId = userAccountId),
            (user.firstName = firstName),
            (user.lastName = lastName),
            (user.birthday = birthday),
            (user.nationalCode = nationalCode),
            (user.email = email),
            (user.iban = iban ? 'IR' + iban : null);
          // this._storageService.set('USER_PROFILE', user);
          this.currentUserSubject.next(user);
          this.refresh();
          // this.setLoggedIn(user);
          resolve(c.result as any);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  // private loggedIn: BehaviorSubject<any> = new BehaviorSubject<any>('');
  // loggedIn$ = this.loggedIn.asObservable();
  // setLoggedIn(value: any) {
  //
  //   this.loggedIn.next(value);
  // }

  refresh() {
    this._storageService.set('USER_PROFILE', this.currentUserValue);
    this.currentUserSubject.next(this.currentUserValue);
  }

  logout() {
    this._storageService.clear();
    this.currentUserSubject.next(null);
  }
}
